import { render, staticRenderFns } from "./customContextMenu.vue?vue&type=template&id=7db08825&scoped=true"
import script from "./customContextMenu.vue?vue&type=script&lang=js"
export * from "./customContextMenu.vue?vue&type=script&lang=js"
import style0 from "./customContextMenu.vue?vue&type=style&index=0&id=7db08825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db08825",
  null
  
)

export default component.exports